import { Box, LinearProgress, Typography } from "@mui/material";

import { useOnboardingStore } from "../../stores/OnboardingStore";

const MODULE_LABELS: Record<string, string> = {
  greeting: "Welcome",
  // Greeting was split into 4 user-step-sized modules. The form is one
  // click of "Save and continue"; each narrative question is its own
  // step. Labels match what the user is doing, not the data shape.
  profile_form: "Your Profile",
  profile_summary: "Your Background",
  profile_goals: "Your Goals",
  task_declaration: "Your Tasks",
  context_upload: "Upload Context",
  profile_completion: "Profile Complete",
  first_question: "First Question",
  answer_verification: "Your Answer",
  wrapup: "Next Steps",
};

export function OnboardingProgress() {
  const { isOnboarding, currentModule, currentModuleIndex, totalModules } =
    useOnboardingStore();

  if (!isOnboarding) return null;

  const progress = ((currentModuleIndex + 1) / totalModules) * 100;
  const label = currentModule
    ? MODULE_LABELS[currentModule] || currentModule
    : "Getting Started";

  return (
    <Box
      data-testid="aa-ftux-progress"
      sx={{
        px: 2,
        py: 1,
        display: "flex",
        alignItems: "center",
        gap: 2,
        borderBottom: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 600, whiteSpace: "nowrap", color: "text.secondary" }}
      >
        Getting Started
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          flex: 1,
          height: 6,
          borderRadius: 3,
          "& .MuiLinearProgress-bar": { borderRadius: 3 },
        }}
      />
      <Typography
        variant="caption"
        sx={{ whiteSpace: "nowrap", color: "text.secondary" }}
      >
        <span data-testid="aa-ftux-progress-label">{label}</span> (
        <span data-testid="aa-ftux-progress-step">
          {currentModuleIndex + 1}/{totalModules}
        </span>
        )
      </Typography>
    </Box>
  );
}

export default OnboardingProgress;
